/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Cost_PriceInputs */

const vi_product_cost_price = /** @type {(inputs: Product_Cost_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá vốn`)
};

/**

* @param {Product_Cost_PriceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_cost_price = /** @type {((inputs?: Product_Cost_PriceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Cost_PriceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_cost_price(inputs)
});